export default "__VITE_ASSET__D3anzI3K__"